import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAzureartifactsComponent } from './simple-icons-azureartifacts.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAzureartifactsComponent ],
    exports:      [ SimpleIconsAzureartifactsComponent ],
    bootstrap:    []
})
export class SimpleIconsAzureartifactsModule {}
